import styled, { css } from 'vue-styled-components';

import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
    GRAY_100_SPAN,
} from '@styles/common.styled.component';

import { ItemBox, ItemWrapper } from '../styles';
import { BLUE, square } from '@/styles/common.styled';

export const SouceItemWrapper = styled(ItemWrapper)`
    max-height: 170px;
    overflow-y: auto;
`;

export const Logo = styled.img`
    width: 12px;
    height: 12px;
`;

export const AskingModalWrapper = styled(FLEX_COLUMN_DIV)``;

export const AskingModalTitle = styled(GRAY_100_SPAN)`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
`;

export const AskingModalDesc = styled(GRAY_100_SPAN)`
    font-size: 16px;
    margin-bottom: 30px;
    white-space: pre-line;
`;

export const AskingModalOptionWrapper = styled(FLEX_COLUMN_DIV)`
    align-items: center;
`;

export const AskingModalOption = styled.div`
    background: ${BLUE(60)};
    padding: 16px 8px;
    color: #fff;
    font-weight: 600;
    border-radius: 2px;
    margin-bottom: 10px;
    width: 320px;
    text-align: center;
    cursor: pointer;
`;

export const BlendedTag = styled('span', { isSelectedSource: Boolean })`
    border-radius: 20px;
    background: var(--color-cyan-40);
    padding: 2px 10px;
    margin-left: 8px;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    flex-shrink: 0;
    ${({ isSelectedSource }) =>
        isSelectedSource &&
        css`
            min-width: max-content;
            margin-right: 4px;
        `}
`;

export const MappingTag = styled(BlendedTag)`
    background: var(--color-green-50);
`;

export const BlendedTagWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    justify-content: left;

    margin-right: 4px;
`;

export const BlendedText = styled.span`
    max-width: 100%;
    display: block;
`;

export const AdditionalInfoWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    padding: 8px 12px;
    margin-top: 8px;
    gap: 6px;
    border-radius: 8px;

    svg {
        ${square(16)};
        flex-shrink: 0;
    }
`;
export const DisconnectedInfoWrapper = styled(AdditionalInfoWrapper)`
    background: var(--color-orange-10);
    border: 1px solid var(--color-orange-20);

    .warning-icon path {
        fill: var(--color-orange-50);
    }
    .next-icon {
        fill: var(--color-orange-50);
    }
`;
export const InvalidInfoWrapper = styled(AdditionalInfoWrapper)`
    background: var(--color-yellow-10);
    border: 1px solid var(--color-yellow-20);

    .warning-icon path {
        fill: var(--color-yellow-70);
    }
    .next-icon {
        fill: var(--color-yellow-70);
    }
`;

export const AdditionalInfoText = styled.span`
    font-size: 14px;
    font-weight: 400;
    color: var(--color-gray-100);
    line-height: 20px;
    word-break: break-all;
`;
export const AdditionalInfoCta = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex-shrink: 0;
    margin-left: auto;
    cursor: pointer;

    svg {
        ${square(16)};
        flex-shrink: 0;
    }
`;

export const AdditionalInfoCtaText = styled.span`
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;
export const DisconnectedInfoCtaText = styled(AdditionalInfoCtaText)`
    color: var(--color-orange-50);
    font-weight: 500;
`;
export const InvalidInfoCtaText = styled(AdditionalInfoCtaText)`
    color: var(--color-yellow-70);
    font-weight: 500;
`;

export const SOURCE_STATUS = {
    DISCONNECTED: 'disconnected',
    DEPRECATED: 'deprecated',
    INVALID: 'invalid',
    DEFAULT: 'default',
};

const ITEM_BOX_STATUS_STYLES = {
    [SOURCE_STATUS.DISCONNECTED]: {
        bg: 'var(--color-orange-10)',
        text: 'var(--color-orange-50)',
    },
    [SOURCE_STATUS.DEPRECATED]: {
        bg: 'var(--color-gray-20)',
        text: 'var(--color-gray-50)',
    },
    [SOURCE_STATUS.INVALID]: {
        bg: 'var(--color-yellow-10)',
        text: 'var(--color-yellow-70)',
    },
    [SOURCE_STATUS.DEFAULT]: {
        bg: BLUE(10),
        text: BLUE(60),
    },
};

const getItemBoxStyle = (status) => ITEM_BOX_STATUS_STYLES[status];

export const DataSourceItemBox = styled(ItemBox, { status: String })`
    background-color: ${({ status }) => getItemBoxStyle(status).bg};

    & .item-text {
        color: ${({ status }) => getItemBoxStyle(status).text};
    }
`;
